import React from 'react';
interface TextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'tel' | 'number';
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}
export function TextField({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  required = false,
  disabled = false
}: TextFieldProps) {
  return <div className="flex flex-col gap-1.5" data-id="element-53">
      <label className="text-sm font-medium text-gray-700" data-id="element-54">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-55">*</span>}
      </label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} required={required} disabled={disabled} className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent disabled:bg-gray-50 disabled:text-gray-500" data-id="element-56" />
    </div>;
}